// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-theme-homestead -> apartment-management-consultants-theme-homestead-milburn -> black-canyon-luxury-apartments
// Generated: 2026-11-03T16:24:21.421Z
// Counts: 8 design, 10 content, 20 slot group, 7 collection binding, 7 section, 0 style

export const designOverrides = {
  "design._site.color.accent": {
    "cssVariable": "--vibe-color-accent",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_3"
  },
  "design._site.color.surface": {
    "cssVariable": "--vibe-color-surface",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  },
  "design._site.color.textMuted": {
    "cssVariable": "--vibe-color-text-muted",
    "overrideType": "VALUE",
    "value": "#303030",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design.SpecialOfferBanner.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "VALUE",
    "value": "#000000",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "propertyoverview.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_short_description"
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p> <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feeguide.aim_code": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_aim_property_code"
  },
  "floor-plans-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Perfect Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Amenities that make every day run smoother.</strong> At Black Canyon Luxury Apartments, resort-inspired spaces and practical conveniences come together in North Phoenix. Start with our well-equipped fitness center and yoga studio, cool off at the resort-style pool, or settle into the poolside ramada, BBQ areas, fire pits, clubhouse Wi-Fi, and gaming spaces when you want a change of scene.</p><p>Back at home, polished finishes keep things easy: granite countertops, stainless steel energy-efficient appliances, hardwood-style flooring, full-size laundry, smart thermostats, walk-in closets with built-in shelving, and your own patio or balcony. Package lockers, valet trash, controlled access, garage options, and a pet washing station add even more everyday ease. See the spaces in the <a class=\"richtext-link\" href=\"/gallery\">photo gallery</a>, then <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> to experience them in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "VALUE",
    "customValue": "602-237-6382",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "floorplanslist.contact_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore The Area"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/neighborhood"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your Home"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanslist.view_all_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/amenities"
      },
      "label": {
        "type": "VALUE",
        "customValue": "View Amenities"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_logo_media.alt_text"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Resident Login"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule A Tour"
      }
    }
  },
  "herocallouts.cta1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Pricing & Availability"
      }
    }
  },
  "petpolicy.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore All Amenities"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "property_apply_now_url",
        "customValue": "/apply-now"
      }
    }
  },
  "hero.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a010cd-d5bc-74fe-8c26-64d5e7c99e8f.webp"
      },
      "video": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/property/6767906449167563/01a1571c-0afd-75cf-9ea5-cc4a9a602142.mp4"
      }
    }
  },
  "imagecallouts.tile1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f7df0-f726-723d-abd6-88dd815f1d54.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Local Charm"
      },
      "subtitle": {
        "type": "VALUE",
        "customValue": "Explore The Neighborhood"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment building exterior with outdoor seating area and games."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/neighborhood"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "imagecallouts.tile2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f7df0-c60d-758f-b70e-47af74454e30.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Unmatched Convenience"
      },
      "subtitle": {
        "type": "VALUE",
        "customValue": "Explore Our Amenities"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with treadmills, weight machines, punching bag, and motivational mural."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/amenities"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "imagecallouts.tile3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f7df0-5daa-768c-b7b5-626c0e2267e1.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Your New Home Awaits"
      },
      "subtitle": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A bright and stylish living room with a large white sofa, coffee table, and decorative art."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "imagecallouts.tile4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f7df0-5269-739f-99c2-e4dc443127ee.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Luxury Design"
      },
      "subtitle": {
        "type": "VALUE",
        "customValue": "View The Gallery"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/gallery"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "parallaxbanner.secondary_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "socialconnect.image1": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "socialconnect.image2": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "socialconnect.image3": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "socialconnect.image4": {
    "sourceIndex": 4,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.communityItems": {
    "limit": null,
    "hiddenIds": [
      "ec_26ebfa4c13193ed84d590644",
      "ec_6a25221918a6fadf3705e1ed",
      "ec_dd37857bd0259b665df4ce4a",
      "ec_1749fab41f2ba90c02449413"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "contactform.office_hours": {
    "limit": null,
    "hiddenIds": [
      "ec_e282df1ed1fede3939d4b4f3"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "footer.office_hours": {
    "limit": null,
    "hiddenIds": [
      "ec_e282df1ed1fede3939d4b4f3"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallerygrid.images": {
    "limit": null,
    "hiddenIds": [
      "custom_6052e2e8-bae3-456d-8cdd-dfd55602771a",
      "custom_4578bc94-0005-49b5-a386-5d05f3b46f2d"
    ],
    "orderedIds": [
      "custom_65b1468a-0996-498e-8686-1b3d6f389468",
      "custom_83b6bbe9-5522-4e2f-9864-d70e887a6488",
      "custom_627fa816-68b3-4445-8c87-723192127021",
      "custom_9932e690-1a1a-4eea-aec4-f09f0a4bfb48",
      "custom_ad6146ba-06c6-4443-85dc-3a88eff4ec61",
      "custom_f565d370-89eb-4918-854e-3940dcaef3ec",
      "custom_063e2053-1f4c-4ecd-8fbe-ea041590e3de",
      "custom_9ab7faaf-d998-4c8c-a12b-06d6b4fd3d99",
      "custom_f00b7a78-0b97-4e0c-b702-7d68b82d3cd6",
      "custom_4578bc94-0005-49b5-a386-5d05f3b46f2d",
      "custom_01d725f0-7d7d-42c7-b6b9-e60d6466896b",
      "custom_d1f7b31e-09a1-456e-88d9-57af39959777",
      "custom_4a83f768-0d46-4426-a874-5025e54b45ea",
      "custom_4320c198-7e58-4354-a0a1-0ff662308a49",
      "custom_6052e2e8-bae3-456d-8cdd-dfd55602771a",
      "custom_7afe39b6-e47d-4c96-a7a5-4a454f9f77bd",
      "custom_4e3e7c98-8ace-492f-b479-9a449510a039",
      "custom_df805b54-1caf-4765-a714-711982a4feb6",
      "custom_5a166f9e-0600-4133-b855-263a161aaa16",
      "custom_1e1f01af-608e-4981-a9b5-482090b6069b",
      "custom_9913c11b-3687-465b-974d-fadd6585925b",
      "custom_4819d02d-454c-4c84-947e-492ec42099d6",
      "custom_2b99424f-de8c-4184-b772-7424fd1c074e",
      "custom_b52a9ded-05dc-4fd8-9313-73fe6c6396cb",
      "custom_f081c5fe-a51c-46d2-9b23-c0faaf45cb16",
      "custom_97ce16b3-d251-40cf-81f0-e2a756b26cea",
      "custom_440089c5-14b4-4155-8023-34d5b2f49e1a",
      "custom_58437221-e744-43c0-9e4e-4e45ac0bbd50"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "header.office_hours": {
    "limit": null,
    "hiddenIds": [
      "ec_e282df1ed1fede3939d4b4f3"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.slideshow": {
    "limit": null,
    "hiddenIds": [
      "custom_998f8a18-fc71-4aba-94e7-08474023b0b5",
      "custom_1e1f01af-608e-4981-a9b5-482090b6069b",
      "custom_4578bc94-0005-49b5-a386-5d05f3b46f2d",
      "custom_9ab7faaf-d998-4c8c-a12b-06d6b4fd3d99",
      "custom_4e3e7c98-8ace-492f-b479-9a449510a039",
      "custom_01d725f0-7d7d-42c7-b6b9-e60d6466896b",
      "custom_e9cfd4ca-654f-49e2-b126-73c5d80ebaf6",
      "custom_627fa816-68b3-4445-8c87-723192127021",
      "custom_af86b763-aa8d-45a2-9b40-2e648f7cd31d",
      "custom_5f294cca-cb01-4733-ad05-58452dd04a89",
      "custom_f565d370-89eb-4918-854e-3940dcaef3ec"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "specialofferbanner.items": {
    "limit": null,
    "hiddenIds": [
      "custom_4acda343-e5d6-4e5d-a07c-0a9e16ea69bf"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "lea-chatbot",
      "blockId": "lea-chatbot",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
